<mat-toolbar>
  <span>{{ title() }}</span>
  <button (click)="close()" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<div class="oo-content">
  <ng-content></ng-content>
</div>

